import axios from 'axios';

export const GetLocationDataApi = async (lat: any, lng: any) => {
    try {
        const config: any = {
            headers: {
                'Accept-Language': 'fa',
            },
        };
        const response = await axios.get(
            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&zoom=18&addressdetails=1`,
            config,
        );
        console.log('testing data:', response.data.address);
        return response.data.address;
    } catch (error) {
        console.error(error);
    }
};
